import React, { Component } from 'react';
import {
	IDisclaimersProps,
	IDisclaimersState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import DisclaimersComponent from '@kurtosys/ksys-app-components/dist/components/overview/Disclaimers';

@inject('appStore', 'disclaimersStore')
@observer
export class Disclaimers extends Component<IDisclaimersProps, IDisclaimersState> {
	static configurationKey: 'disclaimers' = 'disclaimers';
	static styleKey: 'disclaimers' = 'disclaimers';
	constructor(props: IDisclaimersProps) {
		super(props);
	}
	render() {
		const { className, disclaimersStore } = this.props;

		if (!disclaimersStore) {
			return null;
		}

		return (
			<Wrapper className={ className }>
				<DisclaimersComponent { ...disclaimersStore.props } />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Disclaimers, 'disclaimers');

